import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import ActivationPayment from '../../components/blocks/ActivationPayment';
import Box from '../../components/common/Box';
import { updatePaymentDetails } from '../../store/actions/activation';
import { alertError } from '../../store/actions/alert';

function ActivationPaymentContainer(props) {
  const { update } = props;
  const { supplier } = useSelector((state) => state.activation);

  const stripePromise = loadStripe(supplier.stripe_publishable_key);

  return (
    <Box toolbar="Payment Method" wrap={false}>
      <Elements stripe={stripePromise}>
        <ActivationPayment update={update} />
      </Elements>
    </Box>
  );
}

const mapDispatchToProps = (dispatch) => ({
  update: (data) => dispatch(updatePaymentDetails(data)),
  alertError: (error) => dispatch(alertError(error)),
});

export default connect(null, mapDispatchToProps)(ActivationPaymentContainer);

ActivationPaymentContainer.propTypes = {
  update: PropTypes.func.isRequired,
};
